export function mergePermissionId(
  existing: string[] | undefined,
  newId: string,
): string[] {
  return [...(existing ?? []), newId];
}
